import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import {
  Announce,
  DashboardIcon,
  DownArrowIcon,
  EuroIcon,
  Gift,
  LoaderIcon,
  QuestionIcon,
  RecipientIcon,
  SupportIcon,
  TransactionIcon,
} from './Swicons';
import { Transition } from '@headlessui/react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { devURL } from '../../utils';
import { FaGift } from 'react-icons/fa6';
import useAnnouncements from './Announcements';
const token = localStorage.getItem('swToken');

export default function TopBar() {
  const [menuDropdown, setMenuDropdown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {}, [menuDropdown]);
  const announcements = useAnnouncements();
  const pathname = window.location.pathname;

  return (
    <aside className='w-64 min-h-full hidden lg:block' aria-label='Sidebar'>
      <div className='overflow-y-auto py-4 px-3 bg-gray-50 rounded '>
        <ul className='space-y-2 sw-nav'>
          <li className={pathname == '/Dashboard' ? 'menu-active' : ''}>
            <Link
              to='/Dashboard'
              className='flex items-center p-2 text-base font-normal text-gray-900 rounded-lg'
            >
              <DashboardIcon />
              <span className='ml-3'>Dashboard</span>
            </Link>
          </li>

          <li className={pathname == '/Add-Transaction' ? 'menu-active' : ''}>
            <Link
              to='/Add-Transaction'
              className='flex items-center p-2 text-base font-normal text-gray-900 rounded-lg'
            >
              <EuroIcon />
              <span className='ml-3'>Send Money</span>
            </Link>
          </li>
          <li
            className={
              pathname == '/Transaction-List' || pathname == '/Transaction-List'
                ? 'menu-active'
                : ''
            }
          >
            <Link
              to='/Transaction-List'
              className='flex items-center p-2 text-base font-normal text-gray-900 rounded-lg'
            >
              <TransactionIcon />
              <span className='ml-3'>Transfer History</span>
            </Link>
          </li>
          <li
            className={
              pathname == '/Recipient-List' || pathname == '/Add-Recipient'
                ? 'menu-active'
                : ''
            }
          >
            <button
              type='button'
              className='flex items-center p-2 w-full text-base font-normal text-gray-900 rounded-lg transition duration-75 group'
              onClick={() => setMenuDropdown(!menuDropdown)}
            >
              <RecipientIcon />
              <span
                className='flex-1 ml-3 text-left whitespace-nowrap'
                sidebar-toggle-item=''
              >
                Recipients
              </span>
              <DownArrowIcon />
            </button>
            <ul
              className={
                'submenu py-2 space-y-2 ' + (menuDropdown ? 'show' : 'hidden')
              }
            >
              <li>
                <Link
                  to='/Recipient-List'
                  className='flex items-center p-2 pl-11 w-full text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100'
                >
                  Recipient List
                </Link>
              </li>
              <li>
                <Link
                  to='/Add-Recipient'
                  className='flex items-center p-2 pl-11 w-full text-base font-normal text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100'
                >
                  Add Recipient
                </Link>
              </li>
            </ul>
          </li>
          <li className={pathname == '/faq' ? 'menu-active' : ''}>
            <Link
              to='/Faqs'
              className='flex items-center p-2 text-base font-normal text-gray-900 rounded-lg'
            >
              <QuestionIcon />
              <span className='ml-3'>FAQs</span>
            </Link>
          </li>
          <li className={pathname == '/invite' ? 'menu-active' : ''}>
            <Link
              to='/invite'
              className='flex items-center px-2 py-2 text-base font-normal text-gray-900 rounded-lg'
            >
              <span><Gift /></span>
              <span className='ml-3 mt-1 font-bold'>Earn €10</span>
            </Link>
          </li>
          {/*<li className={pathname == "/help" ? "menu-active" : ""}>
            <Link
              to="/help"
              className="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg"
            >
              <SupportIcon />
              <span className="ml-3">Help</span>
            </Link>
          </li>
            */}
        </ul>
        {announcements != '' ? (
          <div className='border-2 border-[#87b8e2] rounded-lg pb-4 mt-2 '>
            <div className='flex p-3'>
              <div className='-mt-1'>
                <Announce />
              </div>
              <p className='ml-3 mt-1 font-extrabold'>Announcements</p>
            </div>
            <hr className='bg-[#87b8e2] h-0.5' />
            <div className='pl-4 mt-4 text-xl'>{parse(announcements)}</div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </aside>
  );
}
